module.exports = __webpack_public_path__ + "static/media/HCMM054.d404f947.jpg";